import script from "./MsgMineMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsgMineMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MsgMineMenu.vue?vue&type=style&index=0&id=026d3a20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026d3a20"]])

export default __exports__